export default "__VITE_ASSET__r22HMskP__"